import React, { Fragment } from "react"
import { isMember, pgaComTld } from "../utils"
import bannerOptions from "./bannerOptions"
import { ordersTriggerOutstandingInvoiceBanner } from "./orderTriggersOutstandingInvoiceBanner"
import { Wrapper, Title, TitleLink } from "./styles"

const OrdersWarning = ({ orders }) => {
  if (!ordersTriggerOutstandingInvoiceBanner(orders)) return null

  return (
    <Wrapper color="maroon" textColor="white">
      <Title textColor="white">
        You have pending invoices that require payment.
      </Title>
      <TitleLink
        href={`https://${pgaComTld}/member/account/invoices`}
        target="_blank"
        rel="noopener noreferrer"
        textColor="white"
      >
        View Invoices
      </TitleLink>
    </Wrapper>
  )
}

export const GenericBanner = ({
  color,
  textColor,
  title,
  link,
  linkText,
  removeMarginTop,
}) => {
  return (
    <Wrapper color={color} removeMarginTop={removeMarginTop}>
      <Title textColor={textColor}>{title}</Title>
      {link && (
        <TitleLink href={link} textColor={textColor}>
          {linkText}
        </TitleLink>
      )}
    </Wrapper>
  )
}

const Banners = ({ me, currentPerson }) => {
  return (
    <>
      <OrdersWarning orders={currentPerson?.orders} />
      {bannerOptions.map((banner, index) => {
        const displayForMembersOrPublic = banner.membersOnly
          ? banner.showBanner && isMember(me)
          : banner.showBanner
        return displayForMembersOrPublic ? (
          <GenericBanner key={index} {...banner} />
        ) : null
      })}
    </>
  )
}

export default Banners
